import axios from "axios";

// Create axios instance
const api = axios.create({
  baseURL: window.baseURL,
  timeout: window.TimeOut,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to inject token
api.interceptors.request.use(
  config => {
    // Get token from localStorage
    const token = localStorage.getItem("accessToken");
    
    // If token exists, add to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;